// extracted by mini-css-extract-plugin
module.exports = {"card":"no-results-card_card__e5bNJ","card__message-title":"no-results-card_card__message-title__Imyzj","card__message":"no-results-card_card__message__uQ8ZY"};